import React, { Component } from "react"
import { Mutation } from "react-apollo"
import { Link } from "react-router-dom"
import Button from "../../components/Button"
import TextField from "../../components/TextField"
import validator from "validator"
import UPDATE_PASSWORD from "../../graphql/updatePassword.graphql"

import "./forgotPassword.scss"

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: "",
      errors: {},
      success: false,
      successMessage: "",
    }
  }

  updateField = (field) => (e) => {
    e.persist()

    this.setState(({ errors }) => ({
      [field]: e.target.value,
      errors: { ...errors, [field]: null },
    }))
  }

  errorHide = () => {
    setTimeout(() => {
      this.setState({ errors: {} })
    }, 5000)
  }

  onSubmit = (e) => {
    e.preventDefault()
    let { email, errors, success } = this.state

    if (success) {
      this.props.onSuccess()
      return
    }

    if (!email) {
      errors.email = "Email Required"
    } else if (!validator.isEmail(email)) {
      errors.email = "Invalid Email"
    }

    if (Object.values(errors).some((value) => !!value)) {
      this.setState({ errors }, () => this.errorHide())
      return
    }

    this.props
      .updatePassword({
        variables: { email },
      })
      .then(({ data }) => {
        let { payload, message } = data.updatePassword

        if (payload !== "success") {
          this.setState(
            ({ errors }) => ({
              errors: { ...errors, submit: message },
            }),
            () => this.errorHide()
          )
        } else {
          this.setState({
            success: true,
            successMessage: message,
          })
        }
      })
      .catch((err) => {
        console.log("forgot password error", err)
        this.setState(
          ({ errors }) => ({
            errors: { ...errors, submit: "Unable to process your request." },
          }),
          () => this.errorHide()
        )
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearFields !== prevProps.clearFields) {
      this.setState({
        email: "",
        success: false,
        successMessage: "",
        errors: {},
      })
    }
  }

  render() {
    let { success, successMessage, email, errors } = this.state

    let inputFields = [
      {
        type: "email",
        value: email,
        fullWidth: true,
        errors: true,
        errorOptions: {
          outline: true,
          showMessage: true,
          message: errors.email,
          hasError: !!errors.email,
        },
        placeholder: "Email Address",
        onChange: this.updateField("email"),
      },
    ]

    if (success) {
      inputFields = []
    }

    return (
      <div className="forgot-password">
        <div className="forgot-password-form">
          <div id="forgot-password-message">
            {this.props.login && (
              <div id="back-to-login" onClick={this.props.login}>
                <span className="glyphicon glyphicon-menu-left" />
                Back to login
              </div>
            )}
            <h2>{success ? "Success!" : "Forgot your password?"}</h2>
            <p>
              {success
                ? successMessage
                : `Enter your email address and we'll send you a link to reset your password.`}
            </p>
          </div>
          {!success &&
            inputFields.map((input, i) => <TextField key={i} {...input} />)}
          {errors.submit && (
            <div className="fpError">
              <p>{errors.submit}</p>
            </div>
          )}
          <Button
            type="submit"
            classes={["primary"]}
            action={this.onSubmit}
            fullWidth
            text={success ? "Ok" : "Send Link"}
          />
          {!success && (
            <p>
              Not a member yet ?{" "}
              <a href="https://etr.ai/request-a-free-trial">Sign up</a>
            </p>
          )}
        </div>
      </div>
    )
  }
}

const ForgotPasswordWithData = (props) => (
  <Mutation mutation={UPDATE_PASSWORD}>
    {(mutate) => <ForgotPassword {...props} updatePassword={mutate} />}
  </Mutation>
)

export default ForgotPasswordWithData
